import { GET_OPERACAO } from "./types";

export default {
    [GET_OPERACAO](state) {
        return state.operacaoCaptacaoEmAberto;
    },
}